import { render } from "./BaseModalWindow.vue?vue&type=template&id=b6361dd0&scoped=true"
import script from "./BaseModalWindow.vue?vue&type=script&lang=js"
export * from "./BaseModalWindow.vue?vue&type=script&lang=js"

import "./BaseModalWindow.vue?vue&type=style&index=0&id=b6361dd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6361dd0"]])

export default __exports__